import { Controller } from "stimulus"
export default class extends Controller {
  static targets = ["container"];

  connect() {
  }

  close() {
    this.containerTarget.classList.add("hidden");
    document.getElementsByTagName('body')[0].classList.remove('not-scrollable');
  }
  
  open() {
    this.containerTarget.classList.remove("hidden");
    document.getElementsByTagName('body')[0].classList.add('not-scrollable');
  }
}
